import * as _ from 'lodash';

// TODO UPDATE AT REGENTS ADMIN FLIP: remove admin date values that are in the past, add next new one
// i.e if the next regents admin is AUG 2018, remove June 2018; add June 2022
export const ValidRegentsPlans = {
  JAN_2021: 'Jan 2021',
  JUN_2021: 'June 2021',
  AUG_2021: 'Aug 2021',
  JAN_2022: 'Jan 2022',
  JUN_2022: 'June 2022',
  AUG_2022: 'Aug 2022',
  JAN_2023: 'Jan 2023',
  JUN_2023: 'June 2023',
  AUG_2023: 'Aug 2023',
  JAN_2024: 'Jan 2024',
  JUN_2024: 'June 2024',
  AUG_2024: 'Aug 2024',
};

export const RegentsPlans = _.assign({}, ValidRegentsPlans, {
  DROP: 'DROP',
});
